import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { lookupStatus } from '../utils/publicAdmissionApi';
import './admissionStyles.css';

export default function PublicApplicationStatusPage() {
    const { schoolID } = useParams();
    const [applicationNumber, setApplicationNumber] = useState('');
    const [phone, setPhone] = useState('');
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setResult(null);
        setLoading(true);
        try {
            const data = await lookupStatus(applicationNumber.trim(), phone.trim());
            setResult(data);
        } catch (err) {
            setError(err.message || 'Lookup failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="public-admission-page">
            <div className="public-admission-header">SIS Revolution — Track application</div>
            <div className="apply-shell">
                <h1>Track application</h1>
                <p className="apply-lede">Enter your application reference and guardian phone number.</p>

                <form className="apply-form" onSubmit={onSubmit} style={{ maxWidth: 420 }}>
                    <label className="full">
                        Application reference
                        <input
                            value={applicationNumber}
                            onChange={(e) => setApplicationNumber(e.target.value)}
                            placeholder="ADM-..."
                            required
                        />
                    </label>
                    <label className="full">
                        Guardian phone
                        <input
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="+233..."
                            required
                        />
                    </label>
                    <button type="submit" className="btn-primary" disabled={loading}>
                        {loading ? 'Checking…' : 'Check status'}
                    </button>
                </form>

                {error && <div className="alert alert-error" style={{ marginTop: '1rem' }}>{error}</div>}

                {result && (
                    <div className="form-section" style={{ marginTop: '1.5rem' }}>
                        <p>
                            <strong>
                                {result.lastname} {result.othernames}
                            </strong>
                        </p>
                        <p>Class: {result.classApplied}</p>
                        <p>
                            Status:{' '}
                            <span className={`status-chip ${result.status}`}>
                                {String(result.status).replace(/_/g, ' ')}
                            </span>
                        </p>
                        {result.studentID && <p>Student ID: {result.studentID}</p>}
                    </div>
                )}

                <p style={{ marginTop: '1.5rem' }}>
                    <Link to={`/apply/${encodeURIComponent(schoolID)}`} className="btn-secondary">
                        Back to application form
                    </Link>
                </p>
            </div>
        </div>
    );
}
